import { useState } from 'react';
import { Modal } from 'react-bootstrap-v5';
import { useSelector } from 'react-redux';
import { RootState } from 'src/services';
import { useAppDispatch } from 'src/services/redux/app/Store';
import { setMobileDeviceReducer, setNewTemplateReducer, setTemplateNumberReducer, setTemplateReducer } from 'src/services/redux/slices/template/template-slice';
import { KTSVG, toAbsoluteUrl } from '../../../../_metronic/helpers';
import { useActionTemplate, useGetTemplate } from '../../services';
import Templates from '../../templates';
import BreakPoint from '../BreakPoint';

type TemplateSwitcherType = {
  selectedItem: number;
};

export default function TemplateSwitcher(props: TemplateSwitcherType) {
  const { selectedItem } = props;
  const dispatch = useAppDispatch();
  const { mutateAsync: actionTemplate } = useActionTemplate();
  const draftTemplate = useSelector<RootState, boolean>((state) => state.template.draftTemplate);
  const [show, setShow] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  useGetTemplate(selectedItem);
  const dismissLocation = () => {
    setShow(false);
    setShowConfirm(false);
  };
  const mobileDevice = useSelector<RootState, boolean>((state) => state.template.mobileDevice);
  const merhcantTemplateId = useSelector<RootState, number>((state) => state.template.merchantTemplateId);
  const saveTemplate = async (templateId: number) => {
    const response: any = await actionTemplate({
      payload: {
        state: 'waiting',
      },
      schema: String(templateId),
    });
    if (response?.template?.status === 200) {
      window.location.replace('/showcase');
    }
  };

  const confirmTemplate = () => {
    setShowConfirm(true);
  };

  const disabledRules = () => {};

  return (
    <>
      <Modal className="modal fade modal-lg" id="kt_modal_image_upload" data-backdrop="static" tabIndex={-1} role="dialog" show={show} aria-hidden="true" onHide={dismissLocation}>
        <div className="modal-content">
          <div className="modal-body">
            <div className="d-flex flex-column gap-2 align-items-center justify-content-center">
              <KTSVG path="/media/icons/duotone/Alerts/alert-triangle.svg" className="svg-icon svg-icon-5x svg-icon-warning" />
              <strong className="fs-3">Yapmış olduğunuz değişikler taslak olarak kaydedilecektir.</strong>
              <strong className="fs-4">Devam etmek istiyor musunuz?</strong>
            </div>
          </div>
          <div className="modal-footer justify-content-center w-full">
            <div className="d-flex gap-2 align-items-center justify-content-center">
              <button type="button" className="btn btn-sm btn-danger" onClick={dismissLocation}>
                Hayır
              </button>
              <button
                className={`btn btn-sm btn-success`}
                onClick={() => (dispatch(setTemplateReducer([])), dispatch(setNewTemplateReducer(false)), dispatch(setTemplateNumberReducer(0)))}
              >
                Evet
              </button>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        className="modal fade modal-lg"
        id="kt_modal_image_upload"
        data-backdrop="static"
        tabIndex={-1}
        role="dialog"
        show={showConfirm}
        aria-hidden="true"
        onHide={dismissLocation}
      >
        <div className="modal-content">
          <div className="modal-body">
            <div className="d-flex flex-column gap-2 align-items-center justify-content-center">
              <KTSVG path="/media/icons/duotone/Alerts/alert-triangle.svg" className="svg-icon svg-icon-5x svg-icon-warning" />
              <strong className="fs-3">Değişiklikleriniz yönetici onayına gönderilecektir.</strong>
              <strong className="fs-4">Onaylıyor musunuz?</strong>
            </div>
          </div>
          <div className="modal-footer justify-content-center w-full">
            <div className="d-flex gap-2 align-items-center justify-content-center">
              <button type="button" className="btn btn-sm btn-danger" onClick={dismissLocation}>
                Hayır
              </button>
              <button className={`btn btn-sm btn-success`} onClick={() => saveTemplate(merhcantTemplateId)}>
                Evet
              </button>
            </div>
          </div>
        </div>
      </Modal>

      <div className="d-flex flex-column w-100 bg-white">
        <div className="d-flex justify-content-between px-5 py-2 gap-2 items-align-center">
          <div>
            <button
              type="button"
              className={`btn btn-sm  btn-light-primary`}
              onClick={() =>
                draftTemplate === true
                  ? (setShow(true), dispatch(setNewTemplateReducer(false)))
                  : (dispatch(setTemplateReducer([])), dispatch(setNewTemplateReducer(false)), dispatch(setTemplateNumberReducer(0)))
              }
              aria-label="Geri dön"
            >
              <KTSVG path="/media/icons/duotone/Navigation/Arrow-left.svg" className="svg-icon-2" />
              GERİ DÖN
            </button>
          </div>
          <div className="d-flex gap-2">
            <button
              type="button"
              className={`btn btn-sm  ${!mobileDevice ? 'btn-danger' : 'btn-light-danger'}`}
              onClick={() => dispatch(setMobileDeviceReducer(false))}
              aria-label="Desktop görünüm"
            >
              <KTSVG path="/media/icons/duotone/Interface/Monitor.svg" className="svg-icon-1" />
              <span className="fs-6">Web Görünümü</span>
            </button>
            <button
              type="button"
              className={`btn btn-sm ${mobileDevice ? 'btn-danger' : 'btn-light-danger'}`}
              onClick={() => dispatch(setMobileDeviceReducer(true))}
              aria-label="Mobil görünüm"
            >
              <KTSVG path="/media/icons/duotone/Devices/iPhone-X.svg" className="svg-icon-1" />
              <span className="fs-6">Mobil Görünüm</span>
            </button>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-center">
          <div className={`d-flex flex-column gap-6 ${mobileDevice ? 'w-375px' : 'container'}`}>
            <div className="d-flex align-items-center justify-content-center">
              <img src={toAbsoluteUrl(`/media/showcasepage-images/${mobileDevice ? 'idefix-header-mobile' : 'idefix-header'}.png`)} alt="Idefix Header" />
            </div>
            {/* Template Area */}
            <Templates templateId={selectedItem} mobileDevice={mobileDevice} />
            {draftTemplate && (
              <div className="d-flex w-100 align-items-center justify-content-center gap-10 mt-5">
                <button
                  className="btn btn-primary"
                  onClick={() => (dispatch(setTemplateReducer([])), dispatch(setNewTemplateReducer(false)), dispatch(setTemplateNumberReducer(0)))}
                >
                  Taslağı Kaydet
                </button>
                <button className="btn btn-success" onClick={() => confirmTemplate()}>
                  Kaydet ve Onaya Gönder
                </button>
              </div>
            )}
            <BreakPoint />
          </div>
        </div>
      </div>
    </>
  );
}
